(function () {
'use strict';
var C = window.TalhoEntregaCfg;
if (!C || window.__talhoEntrega) return;
window.__talhoEntrega = true;
var KEY = 'talho_entrega_v1';
var T = window.TalhoEntregaTextos(C.lang);
var ICONO_ENVIO = window.TalhoEntregaIconos.envio, ICONO_TIENDA = window.TalhoEntregaIconos.tienda, ICONO_X = window.TalhoEntregaIconos.x;
var TIENDAS = (C.tiendas || []).filter(function (t) { return t.pais === C.pais && t.activa; });
var DISP = C.disp || {};
var modo = leer();
function leer() {
try {
var v = JSON.parse(localStorage.getItem(KEY) || 'null');
if (v && v.pais === C.pais && (v.tipo === 'envio' || tienda(v.tienda))) return v;
} catch (e) {}
return null;
}
function guardar(m) {
m.pais = C.pais;
modo = m;
try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {}
pintarTodo();
atributoCarrito();
}
function atributoCarrito() {
if (!modo) return;
try {
fetchOriginal('/cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ attributes: { Entrega: etiqueta(modo) } })
}).catch(function () {});
} catch (e) {}
}
function actual() { return modo || { tipo: 'envio' }; }
function tienda(id) { for (var i = 0; i < TIENDAS.length; i++) if (TIENDAS[i].id === id) return TIENDAS[i]; return null; }
function opciones() {
var o = [{ tipo: 'envio' }];
TIENDAS.forEach(function (t) { o.push({ tipo: 'retiro', tienda: t.id }); });
return o;
}
function etiqueta(m) {
if (m.tipo === 'envio') return T.envio;
var t = tienda(m.tienda);
return T.retirarEn + ' ' + (t ? t.nombre : m.tienda);
}
function igual(a, b) { return a.tipo === b.tipo && (a.tipo === 'envio' || a.tienda === b.tienda); }
function cargarDisp(root) {
var nodos = (root || document).querySelectorAll('script.tt-disp, script.te-disp');
for (var i = 0; i < nodos.length; i++) {
try {
var d = JSON.parse(nodos[i].textContent);
for (var k in d) if (Object.prototype.hasOwnProperty.call(d, k)) DISP[k] = d[k];
} catch (e) {}
}
}
function disponible(vid, m) {
var d = DISP[String(vid)];
if (!d) return true;
if (m.tipo === 'envio') return (d.e || []).indexOf(C.pais) >= 0;
return (d.r || []).indexOf(m.tienda) >= 0;
}
function algunaDisponible(vids, m) {
for (var i = 0; i < vids.length; i++) if (disponible(vids[i], m)) return true;
return !vids.length;
}
function alternativa(vids) {
var ops = opciones();
for (var i = 0; i < ops.length; i++) if (algunaDisponible(vids, ops[i])) return ops[i];
return null;
}
function pintarBarra() {
var bar = document.getElementById('talho-entrega-bar');
if (!bar) return;
var m = actual();
var txt = bar.querySelector('.te-bar__txt');
var ico = bar.querySelector('.te-bar__ico');
var sinElegir = !modo && opciones().length > 1;
if (txt) {
txt.textContent = '';
if (sinElegir) {
txt.textContent = T.sinElegir;
} else if (m.tipo === 'envio') {
var b = document.createElement('strong'); b.textContent = T.envio;
txt.appendChild(b); txt.appendChild(document.createTextNode(' · ' + C.paisNombre));
} else {
var t = tienda(m.tienda);
txt.appendChild(document.createTextNode(T.retirarEn + ' '));
var s = document.createElement('strong'); s.textContent = t ? t.nombre : m.tienda;
txt.appendChild(s);
}
}
if (ico) ico.innerHTML = m.tipo === 'envio' ? ICONO_ENVIO : ICONO_TIENDA;
var btn = bar.querySelector('.te-bar__cambiar');
if (btn) {
btn.hidden = opciones().length < 2;
btn.textContent = sinElegir ? T.elegirBtn : T.cambiar;
}
}
var dlg, pendiente;
function abrir(vid, avisoNoDisp) {
return new Promise(function (resolve) {
if (pendiente) pendiente(false);
pendiente = resolve;
armarDialogo();
var vids = vid ? [String(vid)] : [];
var elegida = actual();
if (vid && !disponible(vid, elegida)) elegida = alternativa(vids) || elegida;
dlg.querySelector('.te-dlg__titulo').textContent = (vid || !modo) ? T.comoRecibir : T.cambiarEntrega;
dlg.querySelector('.te-dlg__sub').textContent = avisoNoDisp ? T.noEnModo.replace('{x}', etiqueta(actual())) : T.explica;
var lista = dlg.querySelector('.te-dlg__ops');
lista.textContent = '';
opciones().forEach(function (op, i) {
var ok = vid ? disponible(vid, op) : true;
var lab = document.createElement('label');
lab.className = 'te-op' + (ok ? '' : ' te-op--no');
var r = document.createElement('input');
r.type = 'radio'; r.name = 'te-modo'; r.value = String(i);
r.checked = igual(op, elegida);
var ic = document.createElement('span'); ic.className = 'te-op__ico';
ic.innerHTML = op.tipo === 'envio' ? ICONO_ENVIO : ICONO_TIENDA;
var cuerpo = document.createElement('span'); cuerpo.className = 'te-op__cuerpo';
var n = document.createElement('span'); n.className = 'te-op__nombre'; n.textContent = etiqueta(op);
var d = document.createElement('span'); d.className = 'te-op__det';
if (op.tipo === 'envio') d.textContent = C.paisNombre;
else { var t = tienda(op.tienda); d.textContent = [t.ciudad, t.listo ? T.listoEn + ' ' + t.listo : ''].filter(Boolean).join(' · '); }
cuerpo.appendChild(n); cuerpo.appendChild(d);
lab.appendChild(r); lab.appendChild(ic); lab.appendChild(cuerpo);
if (vid) {
var est = document.createElement('span'); est.className = 'te-op__estado';
est.textContent = ok ? '✓ ' + T.disponible : '✕ ' + T.sinStock;
lab.appendChild(est);
}
lab.addEventListener('change', function () { actualizarBoton(vid); });
lista.appendChild(lab);
});
dlg.querySelector('.te-dlg__ok').textContent = vid ? T.agregar : T.guardar;
actualizarBoton(vid);
if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
});
}
function seleccion() {
var r = dlg.querySelector('input[name="te-modo"]:checked');
return r ? opciones()[Number(r.value)] : null;
}
function actualizarBoton(vid) {
var op = seleccion();
var ok = !!op && (!vid || disponible(vid, op));
var b = dlg.querySelector('.te-dlg__ok');
b.disabled = !ok;
var aviso = dlg.querySelector('.te-dlg__aviso');
aviso.textContent = op && !ok ? T.noDisponibleEn.replace('{x}', etiqueta(op)) : '';
}
function cerrar(valor) {
if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
var r = pendiente; pendiente = null;
if (r) r(valor);
}
function armarDialogo() {
if (dlg) return;
dlg = document.createElement('dialog');
dlg.className = 'te-dlg';
dlg.setAttribute('aria-labelledby', 'te-dlg-titulo');
dlg.innerHTML =
'<form method="dialog" class="te-dlg__caja">' +
'<div class="te-dlg__cab"><div><h2 id="te-dlg-titulo" class="te-dlg__titulo"></h2><p class="te-dlg__sub"></p></div>' +
'<button type="button" class="te-dlg__x" aria-label="' + T.cerrar + '">' + ICONO_X + '</button></div>' +
'<div class="te-dlg__ops" role="radiogroup"></div>' +
'<p class="te-dlg__aviso" role="status"></p>' +
'<button type="submit" class="te-dlg__ok"></button>' +
'</form>';
document.body.appendChild(dlg);
dlg.querySelector('.te-dlg__x').addEventListener('click', function () { cerrar(false); });
dlg.addEventListener('cancel', function (e) { e.preventDefault(); cerrar(false); });
dlg.addEventListener('click', function (e) { if (e.target === dlg) cerrar(false); });
dlg.querySelector('form').addEventListener('submit', function (e) {
e.preventDefault();
var op = seleccion();
if (!op) return;
guardar({ tipo: op.tipo, tienda: op.tienda });
cerrar(true);
});
}
var fetchOriginal = window.fetch.bind(window);
function idDelCuerpo(body) {
try {
if (!body) return null;
if (typeof body === 'string') {
if (body.charAt(0) === '{') {
var j = JSON.parse(body);
if (j.id) return String(j.id);
if (j.items && j.items[0]) return String(j.items[0].id);
return null;
}
return new URLSearchParams(body).get('id');
}
if (typeof FormData !== 'undefined' && body instanceof FormData) return body.get('id');
if (body instanceof URLSearchParams) return body.get('id');
} catch (e) {}
return null;
}
function respuestaCancelada() {
return new Response(JSON.stringify({ status: 422, message: T.sinAgregar, description: T.sinAgregar }), {
status: 422, headers: { 'Content-Type': 'application/json' }
});
}
window.fetch = function (input, init) {
var args = arguments;
try {
var url = typeof input === 'string' ? input : (input && input.url) || '';
var metodo = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
if (metodo === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0])) {
var vid = idDelCuerpo(init && init.body);
var falta = vid && !disponible(vid, actual());
if ((!modo && opciones().length > 1) || falta) {
return abrir(vid, falta && !!modo).then(function (ok) {
return ok ? fetchOriginal.apply(window, args).then(function (r) { atributoCarrito(); return r; }) : respuestaCancelada();
});
}
return fetchOriginal.apply(window, args).then(function (r) { atributoCarrito(); return r; });
}
} catch (e) {}
return fetchOriginal.apply(window, args);
};
function nota(texto, vids) {
var w = document.createElement('span');
w.className = 'te-nota';
w.appendChild(document.createTextNode(texto + ' '));
var alt = alternativa(vids);
if (alt) {
var b = document.createElement('button');
b.type = 'button'; b.className = 'te-link';
b.textContent = T.disponibleCon.replace('{x}', etiqueta(alt));
b.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation();
guardar({ tipo: alt.tipo, tienda: alt.tienda });
});
w.appendChild(b);
}
return w;
}
function pintarTarjetas() {
var m = actual();
var cards = document.querySelectorAll('.tt-card[data-vid]');
for (var i = 0; i < cards.length; i++) {
var c = cards[i];
var vids = [c.getAttribute('data-vid')];
var vj = c.querySelector('.tt-vjson');
if (vj) { try { vids = JSON.parse(vj.textContent).map(function (v) { return String(v.id); }); } catch (e) {} }
var vieja = c.querySelector('.te-nota');
if (vieja) vieja.parentNode.removeChild(vieja);
var ok = algunaDisponible(vids, m);
c.classList.toggle('te-off', !ok);
if (!ok) {
var info = c.querySelector('.tt-info') || c;
info.appendChild(nota(T.sinStockEn.replace('{x}', etiqueta(m)), vids));
}
}
}
function varianteFicha() {
var f = document.querySelector('#MainContent form[action*="/cart/add"] [name="id"]');
return f ? String(f.value) : (C.varianteFicha ? String(C.varianteFicha) : null);
}
function pintarFicha() {
if (C.template !== 'product') return;
var form = document.querySelector('#MainContent form[action*="/cart/add"]');
if (!form) return;
var caja = document.getElementById('te-ficha');
if (!caja) {
caja = document.createElement('div');
caja.id = 'te-ficha'; caja.className = 'te-ficha';
form.parentNode.insertBefore(caja, form.nextSibling);
}
var vid = varianteFicha();
caja.textContent = '';
if (opciones().length < 2 && (!vid || disponible(vid, actual()))) { caja.hidden = true; return; }
caja.hidden = false;
var m = actual();
opciones().forEach(function (op) {
var fila = document.createElement('div');
var ok = !vid || disponible(vid, op);
fila.className = 'te-ficha__fila' + (ok ? '' : ' te-ficha__fila--no');
var est = document.createElement('span'); est.className = 'te-ficha__est'; est.textContent = ok ? '✓' : '✕';
var n = document.createElement('span'); n.className = 'te-ficha__nombre'; n.textContent = etiqueta(op);
fila.appendChild(est); fila.appendChild(n);
if (modo && igual(op, m)) {
var tag = document.createElement('span'); tag.className = 'te-ficha__tag'; tag.textContent = T.elegida;
fila.appendChild(tag);
} else if (ok) {
var b = document.createElement('button'); b.type = 'button'; b.className = 'te-link'; b.textContent = T.elegir;
b.addEventListener('click', function () { guardar({ tipo: op.tipo, tienda: op.tienda }); });
fila.appendChild(b);
} else {
var s = document.createElement('span'); s.className = 'te-ficha__det'; s.textContent = T.sinStock;
fila.appendChild(s);
}
caja.appendChild(fila);
});
}
function pintarCarrito() {
if (C.template !== 'cart') return;
fetchOriginal('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
var m = actual();
var faltan = (cart.items || []).filter(function (it) { return !disponible(it.variant_id, m); });
var caja = document.getElementById('te-carrito');
if (!faltan.length) { if (caja) caja.hidden = true; return; }
if (!caja) {
caja = document.createElement('div');
caja.id = 'te-carrito'; caja.className = 'te-carrito'; caja.setAttribute('role', 'status');
var main = document.getElementById('MainContent');
main.insertBefore(caja, main.firstChild);
}
caja.hidden = false;
caja.textContent = '';
var h = document.createElement('p'); h.className = 'te-carrito__tit';
h.textContent = (faltan.length === 1 ? T.unoNoDisp : T.variosNoDisp.replace('{n}', faltan.length)).replace('{x}', etiqueta(m));
caja.appendChild(h);
faltan.forEach(function (it) {
var fila = document.createElement('div'); fila.className = 'te-carrito__fila';
var n = document.createElement('span'); n.textContent = it.product_title + (it.variant_title ? ' · ' + it.variant_title : '');
var q = document.createElement('button'); q.type = 'button'; q.className = 'te-btn te-btn--sec'; q.textContent = T.quitar;
q.addEventListener('click', function () {
fetchOriginal('/cart/change.js', {
method: 'POST', headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: it.key, quantity: 0 })
}).then(function () { location.reload(); });
});
fila.appendChild(n); fila.appendChild(q);
caja.appendChild(fila);
});
var alt = alternativa(faltan.map(function (it) { return String(it.variant_id); }));
if (alt && !igual(alt, m)) {
var v = document.createElement('button'); v.type = 'button'; v.className = 'te-btn';
v.textContent = T.pasarA.replace('{x}', etiqueta(alt));
v.addEventListener('click', function () { guardar({ tipo: alt.tipo, tienda: alt.tienda }); });
caja.appendChild(v);
}
}).catch(function () {});
}
function pintarTodo() {
pintarBarra(); pintarTarjetas(); pintarFicha(); pintarCarrito();
}
function iniciar() {
cargarDisp();
pintarTodo();
var bar = document.getElementById('talho-entrega-bar');
var btn = bar && bar.querySelector('.te-bar__cambiar');
if (btn) btn.addEventListener('click', function () { abrir(null, false); });
var espera;
var propio = function (n) { return n.nodeType !== 1 || n.classList.contains('te-nota') || n.id === 'te-ficha' || n.id === 'te-carrito'; };
new MutationObserver(function (muts) {
for (var i = 0; i < muts.length; i++) {
var t = muts[i].target;
if (t && t.closest && t.closest('#te-ficha, #te-carrito, .te-dlg, .te-nota')) continue;
var nodos = [].slice.call(muts[i].addedNodes).concat([].slice.call(muts[i].removedNodes));
if (nodos.length && nodos.every(propio)) continue;
clearTimeout(espera);
espera = setTimeout(function () { cargarDisp(); pintarTarjetas(); pintarFicha(); }, 150);
return;
}
}).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
document.addEventListener('change', function (e) {
if (e.target && e.target.closest && e.target.closest('#MainContent form, variant-picker, .variant-picker')) setTimeout(pintarFicha, 50);
});
document.addEventListener('cart:update', function () { setTimeout(pintarCarrito, 300); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
else iniciar();
})();